export const css = {
    root: '_2R75VD-Y',
    value: 'EDcb2DBj',
    selectedIcon: '_1H4IwGtm',
    input: '_3jb-WZZT',
    inputWrapper: '_3ntCEitF',
    values: '_2CnErxLI',
    ' _key': 'apic-theme/dojo/chip-typeahead'
};
export default css;
